module.exports = __webpack_public_path__ + "img/ksj007.prt.3e7f1757.jpg";